<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HGzVdH/tc-custom/9781250030009.jpg?1730634856013" alt="This image is the cover for the book Dandy Gilver and a Bothersome Number of Corpses, Dandy Gilver Murder Mystery Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dandy Gilver and a Bothersome Number of Corpses, Dandy Gilver Murder Mystery Series
      </h1>
      <p class="bookDescription body article font2">
        <b>In this historical cozy mystery set in 1920s Scotland, an upper-class sleuth goes undercover to find a killer at an all-girls school.</b><br/><br/>Bored with her wealthy life after the Great War, aristocratic wife and mother Dandy Gilver decides to become a private investigator. Her current case has her traveling to an all-girls school in the Scottish seaside town of Portpatrick where a childhood friend has disappeared. Soon, Dandy discovers that her missing chum, now a teacher, is not the only thing that’s off in Portpatrick. Other teachers have been vanishing as well . . . at an alarming rate. To find some answers, Dandy must go undercover as a new member of the staff, but one misstep could have her dismissed permanently . . .<br/><br/><b>“Fans of historical mysteries and old-fashioned whodunits will enjoy <i>Dandy Gilver and a Bothersome Number of Corpses</i>. . . . A very satisfying whodunit that was both intriguing and creepy.” —<i>Gumshoe Review</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catriona McPherson
      </h2>
      
      <p class="authorDescription body article"><P>CATRIONA MCPHERSON was born near Edinburgh, where she received her Ph.D.  Her previous Dandy Gilver mystery, <I>Dandy Gilver and the Proper Treatment of Bloodstains</I>, won the Sue Feder Memorial Award in 2012. Catriona lives in Davis, California, with her husband and two cats.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Minotaur
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7395025c